import { Container } from "@mui/material";
import Page from "src/components/Page";
import PageHeader from "src/components/PageHeader";
import useLocales from "src/hooks/useLocales";

import AnalyticsPanel from "./AnalyticsPanel";

// ----------------------------------------------------------------------

export const OverView = () => {
	const { translate } = useLocales();
	return (
		<Page title={translate("account_popover.overview")}>
			<Container maxWidth={"xl"}>
				<PageHeader title={translate("account_popover.overview")} back={false} />
				<AnalyticsPanel product='' />
			</Container>
		</Page>
	);
};

export default OverView;
